'user strict'
const ex = require('../lib/error')
const getToken = require('../lib/common').OPTGen
const jwt = require('jsonwebtoken')
const moment = require('moment')
const uploadFile = require('../services/uploadFile')
const excel = require('exceljs')
const fs = require('fs');
var sizeOf = require('image-size');

const sequelize = require('sequelize')
const Op = sequelize.Op
const users = require('../models').users
const pincodes = require('../models').pincodes
const userTokens = require('../models').userTokens
const otp = require('../lib/otp')

const getHeightAndWidth = require('../utils/users').getHeightAndWidth
const imageCompress = require('../utils/users').imageCompress

const getLocation =  require('../services/pincode').getLocationByPincode
const _getSignupUrl = require('../services/otpless').getSignupUrl
const _getUserDetails = require('../services/otpless').getUserDetails

const createUser = (req, res, next) => {
  users
    .create(req.params)
    .then(user => {
      req.responseObject.messageCode = 'MAUD001'
      req.responseObject.data = user.dataValues
      next()
    })
    .catch(error => {
      let errCode
      if (error.name === 'SequelizeUniqueConstraintError') {
        errCode = 'MAUD003'
        ex.raiseError(req, res, errCode, 400, error)
      } else {
        errCode = 'MAUD004'
        ex.raiseError(req, res, errCode, 500, error)
      }
    })
}

const updateUser = (req, res, next) => {

  if (req.body != null) {
    
    if(req.responseObject.data.state && req.responseObject.data.city){
      req.body.state = req.responseObject.data.state,
      req.body.city = req.responseObject.data.city
    }

    users.update(req.body, {
      where: { userid: req.params.userid },
      returning: true,
      plain: true
    })
      .then(user => {
        users.findOne({ where: { userid: req.params.userid } })
          .then(userdata => {
            req.responseObject.messageCode = 'MAUD007'
            req.responseObject.data = userdata.dataValues
            next()
          })
          .catch(error => {
            ex.raiseError(req, res, 'MAUD008', 500, error)
          })
      })
      .catch(error => {
          ex.raiseError(req, res, 'MAUD008', 500, error)
      })
  } else {
    ex.raiseError(req, res, 'MAUD009', 400, "Invalid Request")
  }
}

const locoationByPincode = async (req, res, next) => {

  if(!req.body || !req.body.pincode || req.body.pincode.toString().length !== 6) {
    ex.raiseError(req, res, 'MAUD006', 400, "Invalid Pincode");

  } else {

    let userLocation = await pincodes.findOne({ where: { pincode: req.body.pincode } })
    .then(location => {
      if(location != null){
        req.responseObject.messageCode = 'OVA005'
        req.responseObject.data.state = location.state
        req.responseObject.data.city = location.city
      }
      return location;
    }).catch((error) => {
      let errCode
      errCode = 'BICEEO006'
      ex.raiseError(req, res, errCode, 500, error)
    });
    if(!userLocation) {
      userLocation = await getLocation(req.body.pincode);
      if (userLocation === null || userLocation.body[0].PostOffice === null) {
        req.responseObject.data = "";
        ex.raiseError(req, res, 'MAUD006', 400, "Invalid Pincode");
        return;
      }
      const city = userLocation.body[0].PostOffice[0].District;
      const state = userLocation.body[0].PostOffice[0].State
      req.responseObject.messageCode = 'OVA005'
      req.responseObject.data.state = state
      req.responseObject.data.city = city
      await pincodes.create({ pincode: userLocation.body[0].PostOffice[0].Pincode,
                        area: userLocation.body[0].PostOffice[0].Name,
                        city: userLocation.body[0].PostOffice[0].District,
                        state: userLocation.body[0].PostOffice[0].State
      }).catch(error => {
        let errCode
        if (error.name === 'SequelizeUniqueConstraintError') {
          errCode = 'MAUD003'
        } else {
          errCode = 'MAUD004'
        }
        ex.raiseError(req, res, errCode, 500, error)
      })
    }

    next();
  }

}

const sendOTP = (req, res, next) => {

  if(!req.body){
    ex.raiseError(req, res, "Invalid request!", 400, "Invalid request!");
  }else{

    // sending OTP in a register/login request => new/existing number should get OTP
    // sending OTP in an "update profile with mobile no. request" => only new number should get OTP
    const isNewNumber = !req.responseObject.data.hasOwnProperty("userid");
    const isUpdateMobileNo = req.body.hasOwnProperty("isUpdateMobileNo") && req.body.isUpdateMobileNo === "true";

    if (!isUpdateMobileNo || (isUpdateMobileNo && isNewNumber)) {
      if(req.body.mobileNo && req.body.mobileNo.length == 10){
        let OTP = getToken();
        req.responseObject.data = {}
        req.responseObject.data.mobileNo = req.body.mobileNo
        req.responseObject.data.otp = OTP
        otp.sendOTP({
          dest: req.body.mobileNo,
          otp: OTP
        }).then((d) => {
          next()
        }).catch((error) => {
          let errCode
          errCode = 'BICEEO006'
          ex.raiseError(req, res, errCode, 500, error)
        })
      }else{
        ex.raiseError(req, res, "Invalid Mobile number!", 400, "Invalid Mobile number!");
      }
    } else {
      req.responseObject.data = {};
      next();
    }
  }
}

const checkUserIsRegistered = (req, res, next) => {
  users.findOne({ where: { mobileNo: req.body.mobileNo } })
    .then(user => {
      if (user != null) {
        req.responseObject.data = user.dataValues;
      } else {
        req.responseObject.data = {}
      }
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'BICEEO006'
      ex.raiseError(req, res, errCode, 500, error)
    })

}
const sendOTPViaWebService = (req, res, next) => {
  const top = getToken()
}

const verifyOTP = (req, res, next) => {

  next()
}

const generateToken = (req, res, next) => {
  if (req.responseObject.data.hasOwnProperty("userid")) {
    let token = {
      userid: req.responseObject.data.userid,
      mobileNo: req.responseObject.data.mobileNo
    }
    let userToken = jwt.sign(token, process.env.SALT, {
      expiresIn: '3y'
    })

    users
      .update({ userToken: userToken }, {
        where: {
          userid: req.responseObject.data.userid
        }
      })
      .then(user => {
        req.responseObject.data.userToken = userToken
        next()
      })
      .catch(error => {
        ex.raiseError(req, res, 'USR016', 500, error)
      })
  }
  else {
    next()
  }
}

const updatePic = async (req, res, next) => {
  if (req.body.hasOwnProperty("isProfileImage")) {
    if (req.body.isProfileImage === '0') {
      req.body.profileImage = null;
    }
    else {
      if (req.files && req.files.profileImage && req.files.profileImage.size > 0) {
        const profileImagePath = req.files.profileImage.path.replace('\\', '/')
        const dest = __dirname + "/../../public/profile/" + profileImagePath.substring(profileImagePath.lastIndexOf('/') + 1)
        var dimensions = sizeOf(profileImagePath);
        const [height, width] = getHeightAndWidth(dimensions.width, dimensions.height)
        let check = imageCompress(profileImagePath, height, width, dest, req.files.profileImage.path)
        check = await Promise.all([check])
        console.log(check);
        if (!check[0]) {
          ex.raiseError(req, res, 'MAUD006', 400, "File Size is too large");
        }
        const destPath = "profile/" + profileImagePath.substring(profileImagePath.lastIndexOf('/') + 1)

        let publicUrl = uploadFile(dest, destPath)
        publicUrl = await Promise.all([publicUrl])
        req.body.profileImage = publicUrl[0];
        fs.unlinkSync(dest);
      }
    }
    delete req.body.isProfileImage
  }
  if (req.body.hasOwnProperty("isSignatureImage")) {
    if (req.body.isSignatureImage === '0') {
      req.body.signatureImage = null;
    }
    else {
      if (req.files && req.files.signatureImage && req.files.signatureImage.size > 0) {
        const signatureImagePath = req.files.signatureImage.path.replace('\\', '/')
        const dest = __dirname + "/../../public/signature/" + signatureImagePath.substring(signatureImagePath.lastIndexOf('/') + 1)
        var dimensions = sizeOf(signatureImagePath);
        const [height, width] = getHeightAndWidth(dimensions.width, dimensions.height)
        let check = imageCompress(signatureImagePath, height, width, dest, req.files.signatureImage.path)
        check = await Promise.all([check])
        if (!check[0]) {
          ex.raiseError(req, res, 'MAUD006', 400, "File Size is too large");
        }
        const destPath = "signature/" + signatureImagePath.substring(signatureImagePath.lastIndexOf('/') + 1)

        let publicUrl = uploadFile(dest, destPath)
        publicUrl = await Promise.all([publicUrl])
        req.body.signatureImage = publicUrl[0];
        fs.unlinkSync(dest);
      }
    }
    delete req.body.isSignatureImage
  }

  if (req.body.hasOwnProperty("isCompanyLogo")) {
    if (req.body.isCompanyLogo === '0') {
      req.body.companyLogo = null;
    }
    else {
      if (req.files && req.files.companyLogo && req.files.companyLogo.size > 0) {
        const companyLogoPath = req.files.companyLogo.path.replace('\\', '/')
        const dest = __dirname + "/../../public/logo/" + companyLogoPath.substring(companyLogoPath.lastIndexOf('/') + 1)
        var dimensions = sizeOf(companyLogoPath);
        const [height, width] = getHeightAndWidth(dimensions.width, dimensions.height)
        let check = imageCompress(companyLogoPath, height, width, dest, req.files.companyLogo.path)
        check = await Promise.all([check])
        if (!check[0]) {
          ex.raiseError(req, res, 'MAUD006', 400, "File Size is too large");
        }
        const destPath = "logo/" + companyLogoPath.substring(companyLogoPath.lastIndexOf('/') + 1)

        let publicUrl = uploadFile(dest, destPath)
        publicUrl = await Promise.all([publicUrl])
        req.body.companyLogo = publicUrl[0];
        fs.unlinkSync(dest);
      }
    }
    delete req.body.isCompanyLogo
  }
  next()
}

// find user's details by their ID
const getUserById = (req, res, next) => {
  users
    .findOne({
      where: {
        userid: req.params.userid
      }
    })
    .then(user => {
      if(!user) {
        ex.raiseError(req, res, 'MAUD005', 404, "No User Found");
      } else {
        req.responseObject.data = user;
        next();
      }
    })
    .catch(error => {
      ex.raiseError(req, res, 'MAUD006', 500, error);
    });
}

const getAllUsers = (req, res, next) => {
  users
    .findAll({
      where: {
        createdAt: {
          [Op.between]: [moment().subtract(req.params.noMonth, 'months').startOf('months'),
          moment().subtract(req.params.noMonth, 'months').endOf('months')]
        }
      }
    })
    .then(users => {
      req.responseObject.messageCode = 'MAUD005'
      req.responseObject.data = users
      next()
    })
    .catch(error => {
      let errCode
      errCode = 'MAUD006'
      ex.raiseError(req, res, errCode, 500, error)
    })
}

const createUserXls = (req, res, next) => {
  const workbook = new excel.Workbook();
  const users = workbook.addWorksheet('users');
  const A = 'A'
  const B = 'B'
  const C = 'C'
  const D = 'D'
  const E = 'E'
  const F = 'F'
  const G = 'G'
  const H = 'H'
  const I = 'I'
  const J = 'J'
  const K = 'K'

  let rowNo = 1
  users.getCell(A + rowNo).value = "userid"
  users.getCell(B + rowNo).value = "shopName"
  users.getCell(C + rowNo).value = "shopAddr"
  users.getCell(D + rowNo).value = "mobileNo"
  users.getCell(E + rowNo).value = "state"
  users.getCell(F + rowNo).value = "city"
  users.getCell(G + rowNo).value = "pincode"
  users.getCell(H + rowNo).value = "gstNo"
  users.getCell(I + rowNo).value = "email"
  users.getCell(J + rowNo).value = "fulllname"
  users.getCell(K + rowNo).value = "registrationDate"
  // users.getCell(K + rowNo).value = "pincode"
  // users.getCell(L + rowNo).value = "pincode"

  rowNo++;
  req.responseObject.data.forEach((user, position) => {
    users.getCell(A + rowNo).value = user.userid
    users.getCell(B + rowNo).value = user.shopName
    users.getCell(C + rowNo).value = user.shopAddr
    users.getCell(D + rowNo).value = user.mobileNo
    users.getCell(E + rowNo).value = user.state
    users.getCell(F + rowNo).value = user.city
    users.getCell(G + rowNo).value = user.pincode
    users.getCell(H + rowNo).value = user.gstNo
    users.getCell(I + rowNo).value = user.email
    users.getCell(J + rowNo).value = user.fulllname
    users.getCell(K + rowNo).value = user.createdAt
    rowNo++
  });


  const fileName = "users_" + new Date().getTime() + ".xls"
  workbook.xlsx.writeFile(__dirname + '/../../public/users/' + fileName)
  req.responseObject.data = "http://" + (req.headers.host ? req.headers.host : req.connection.remoteAddress) + "/users/" + fileName

  next()
}

const getSignupUrl = async (req, res, next) => {

  let httpsRes = await _getSignupUrl();
  if(httpsRes && httpsRes.statusCode === 200) {
    req.responseObject.data.url = httpsRes.body.url;
    next();
  } else {
    ex.raiseError(req, res, "Cannot get Signup URL", 500, "Cannot get Signup URL");
  }
}

const getUserDetails = async (req, res, next) => {

  // get user details from OTPless with token
  // generate OTP, save in db and attach
  if(!req.body || !req.body.token) {
    ex.raiseError(req, res, "Token is required", 400, "Token is required");
  } else {
    let httpsRes = await _getUserDetails(req.body.token);
    let OTP = getToken();

    if(httpsRes && httpsRes.statusCode === 200) {

      let mobileNo = httpsRes.body.mobile;
      if(mobileNo.length === 12) {
        mobileNo = mobileNo.substring(2);
      } else if(mobileNo.length === 13) {
        mobileNo = mobileNo.substring(3);
      }

      req.responseObject.data.mobileNo = mobileNo;
      req.responseObject.data.otp = OTP;
      next();
      
    } else {
      ex.raiseError(req, res, "Cannot get User Details", 500, "Cannot get User Details");
    }
  }
}

module.exports = {
  createUser,
  verifyOTP,
  checkUserIsRegistered,
  // updateProfilePic,
  updateUser,
  //   login,
  //   updateToken,
  getUserById,
  getAllUsers,
  sendOTP,
  generateToken,
  createUserXls,
  updatePic,
  locoationByPincode,
  getSignupUrl,
  getUserDetails
}
